import {WebClient} from "../../store/clients/client";
import {LicenseKey, LicenseKeyRequest} from "../../models/license";

// ---------------------------------------- ADMIN ----------------------------------------
export async function adminGetLicenseKeysPaginated(page:number) {
    try {
        const response = await WebClient.AdminGetLicenseKeysPaginated(page);

        if (response.status === 200) {
            return response.data['results'] as LicenseKey[]
        }
    }catch (e) {}

    return [] as LicenseKey[];
}

export async function adminCreateLicenseKey(key:LicenseKeyRequest) {
    try {
        const response = await (WebClient.AdminNewLicenseKey as (license: LicenseKeyRequest) => Promise<any>)(key);

        if (response.status === 200) {
            return response.data as LicenseKey
        }
    }catch (e) {}

    return {} as LicenseKey;
}

export async function adminUpdateLicenseKey(key:LicenseKeyRequest) {
    try {
        const response = await WebClient.AdminUpdateLicenseKey(key);

        if (response.status === 200) {
            return response.data as LicenseKey
        }
    }catch (e) {}

    return {} as LicenseKey;
}

export async function adminDeleteLicenseKey(key:LicenseKey) : Promise<boolean> {
    try {
        const response = await WebClient.AdminDeleteLicenseKey(key);

        if (response.status === 204) {
            return true
        }
    }catch (e) {}

    return false;
}


// ---------------------------------------- USER ----------------------------------------
export async function createFreeTrialLicenseKey(): Promise<LicenseKey> {
    try {
        const response = await WebClient.UserNewFreeTrialLicense();

        if (response.status === 201) {
            return response.data as LicenseKey;
        }
    } catch (e: any) {}
    return {} as LicenseKey;
}

export async function userGetLicenseKeysPaginated(page:number) {
    try {
        const response = await WebClient.UserGetLicenseKeysPaginated(page);

        if (response.status === 200) {
            return response.data['results'] as LicenseKey[]
        }
    }catch (e) {}

    return [] as LicenseKey[];
}
